<template>
  <div id="appd">
    <RouterView />
    <vue-progress-bar/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>
